var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91663 14L5.24996 15.1667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 14.5835L22.75 15.1668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 20.4167L9.61999 19.7001C10.0462 18.6346 10.2593 18.1018 10.7038 17.8009C11.1482 17.5 11.722 17.5 12.8697 17.5H15.1304C16.2781 17.5 16.852 17.5 17.2963 17.8009C17.7407 18.1018 17.9539 18.6346 18.3801 19.7001L18.6667 20.4167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 19.8335V23.1958C2.33337 23.6376 2.61425 24.0417 3.0589 24.2393C3.34742 24.3675 3.62298 24.5002 3.95572 24.5002H5.96103C6.29376 24.5002 6.56933 24.3675 6.85785 24.2393C7.3025 24.0417 7.58337 23.6376 7.58337 23.1958V21.0002",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4166 21.0002V23.1958C20.4166 23.6376 20.6976 24.0417 21.1422 24.2393C21.4307 24.3675 21.7063 24.5002 22.039 24.5002H24.0443C24.377 24.5002 24.6526 24.3675 24.9411 24.2393C25.3857 24.0417 25.6666 23.6376 25.6666 23.1958V19.8335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 9.91683L24.5 9.3335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 9.91683L3.5 9.3335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.5L6.51968 6.69094C7.03304 5.15089 7.28971 4.38087 7.90078 3.94044C8.51185 3.5 9.32352 3.5 10.9469 3.5H17.0532C18.6765 3.5 19.4881 3.5 20.0992 3.94044C20.7103 4.38087 20.967 5.15089 21.4803 6.69094L22.75 10.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25004 10.5H22.75C23.8668 11.6824 25.6667 13.3291 25.6667 15.1662V19.2152C25.6667 19.8808 25.224 20.4409 24.6363 20.5187L21 21H7.00004L3.36373 20.5187C2.77618 20.4409 2.33337 19.8808 2.33337 19.2152V15.1662C2.33337 13.3291 4.1333 11.6824 5.25004 10.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleIcon);
export default __webpack_public_path__ + "static/media/VehicleIcon.d53f6b8bb215c63e260ecb7978b03482.svg";
export { ForwardRef as ReactComponent };